import { makeStyles } from '@material-ui/core/styles';

import { complementaryColor, mainColor, minimWidthBasicButton } from '../utils/constants';

// Palete de colors aqui: https://material-ui.com/customization/palette/

const fieldStyles = makeStyles((theme) => ({
  // *********************** HEADER ***********************
  appBarHeader: {
    backgroundColor: mainColor,
    flexGrow: 1,
  },
  appBarTitleHeader: {
    color: complementaryColor,
    textAlign: 'right',
    // flexGrow: 1,
  },
  appBarAvatarImageHeader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    width: 100,
    heigth: 100,
  },
  language: {
    textAlign: 'right',
    marginRight: theme.spacing(3),
    flexGrow: 1, // Del grup de components a la part dreta de la capçalera, el flexGrow: 1 s'ha de posar al que està més a l'esquerra per a que el grup quedi a la dreta
  },
  languageSelector: {
    // minWidth: 120,
    width: 70,
    backgroundColor: '#ffffff',
  },
  avatarDefault: {
    height: 25,
  },
  avatar: {
    height: 30,
  },
  divider: {
    height: '5px',
  },
  row: {
    display: 'flex',
    direction: 'row',
    alignItems: 'center',
  },
  // *********************** ICONES ***********************
  iconBody: {
    color: complementaryColor,
  },
  iconButtonHeader: {
    color: complementaryColor,
  },
  iconMenuDrawer: {
    color: 'white',
  },
  iconSearch: {
    color: '#808080',
  },
  // *********************** BOTONS ***********************
  acceptButton: {
    backgroundColor: complementaryColor,
    color: '#FFF',
    fontWeight: 'bold',
    minWidth: minimWidthBasicButton,
    '&:hover': {
      backgroundColor: mainColor,
      color: '#FFF',
    },
  },
  cancelButton: {
    backgroundColor: '#f44336',
    fontWeight: 'bold',
    color: '#FFF',
    minWidth: minimWidthBasicButton,
    '&:hover': {
      backgroundColor: '#d32f2f',
      color: '#FFF',
    },
  },
  editButton: {
    backgroundColor: complementaryColor,
    color: '#FFF',
    fontWeight: 'bold',
    minWidth: minimWidthBasicButton,
    '&:hover': {
      backgroundColor: mainColor,
      color: '#FFF',
    },
  },
  updateButton: {
    backgroundColor: complementaryColor,
    color: '#FFF',
    minWidth: minimWidthBasicButton,
    // fontWeight: 'bold',
    '&:hover': {
      backgroundColor: mainColor,
      color: '#FFF',
    },
  },
  warnButton: {
    backgroundColor: '#ff9800',
    fontWeight: 'bold',
    color: '#FFF',
    minWidth: minimWidthBasicButton,
    '&:hover': {
      backgroundColor: '#f57c00',
      color: '#FFF',
    },
  },
  // *********************** FORMULARIS ***********************
  formControlLabel: {
    paddingBottom: theme.spacing(0.5),
  },
  formLabel: {
    paddingRight: theme.spacing(2),
    color: 'black',
  },
  // *********************** FOOTER ***********************
  footer: {
    padding: theme.spacing(1),
    textAlign: 'center',
    flexGrow: 1,
  },
}));

export default fieldStyles;
